<template>
  <div :class="['question-rich-text', { 'has-ai-footer': enableAiOptimize && !disabled }]">
    <div class="ql-container">
      <div :class="['el-textarea', disabled?'is-disabled':'']">
        <div :class="['ql-editor', 'el-textarea__inner']"
             :placeholder="placeholder"
             v-html="currentValue"
             @mouseover="showRichTextEditor"></div>
      </div>
    </div>
    <div v-if="enableAiOptimize && !disabled"
         class="question-rich-text-footer">
      <el-tooltip content="AI 优化描述内容"
                  placement="top">
        <el-button type="text"
                   size="mini"
                   :loading="aiLoading"
                   style="padding: 0;"
                   @click.stop="onAiOptimize">
          <span v-if="!aiLoading">AI 优化</span>
        </el-button>
      </el-tooltip>
    </div>

    <el-dialog title="AI 优化预览"
               :visible.sync="previewVisible"
               width="720px"
               append-to-body
               @close="onPreviewClose">
      <el-row :gutter="16">
        <el-col :span="12">
          <div class="ai-preview-label">原文</div>
          <div class="ai-preview-content"
               v-html="previewOriginal"></div>
        </el-col>
        <el-col :span="12">
          <div class="ai-preview-label">优化后</div>
          <div class="ai-preview-content"
               v-html="previewOptimized"></div>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="previewVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="applyOptimized">应用</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QuestionQuillEditor from '@/views/question-editor/components/question-quill-editor'
import { optimizeRichText } from '@/services/siliconflow.api'

export default {
  components: {},
  inject: ['page', 'SjQuestion'],
  props: {
    value: String,
    disabled: Boolean,
    enableAiOptimize: {
      type: Boolean,
      default: false,
    },
    aiContext: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入内容',
    },
  },
  data () {
    return {
      aiLoading: false,
      previewVisible: false,
      previewOriginal: '',
      previewOptimized: '',
    }
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    showRichTextEditor () {
      // 禁止编辑
      if (this.disabled) return false

      let text = this.$el.getBoundingClientRect()
      // 获得容器的相对屏幕的位置信息
      let container = this.SjQuestion.$el
      let question = container.getBoundingClientRect()
      // 获得文本框的宽度，小于500px时将会产生换行
      let offsetHeight = 35
      if (text.width < 300) {
        offsetHeight = 83
      } else if (text.width < 500) {
        offsetHeight = 59
      }
      // 获得绝对坐标
      let top = text.top - question.top - offsetHeight
      let left = text.left - question.left
      QuestionQuillEditor.open(this.currentValue, {
        container,
        style: {
          top: top + 'px',
          left: left + 'px',
          width: text.width - 2 + 'px',
          minHeight: 97 + offsetHeight - 2 + 'px',
        },
        callback: ({html}) => {
          this.currentValue = html
        },
        onClick: _ => this.$emit('click', _)
      })
    },
    onAiOptimize () {
      if (this.aiLoading) return

      this.aiLoading = true
      optimizeRichText({
        content: this.currentValue,
        context: this.aiContext,
      }).then((optimized) => {
        this.previewOriginal = this.currentValue
        this.previewOptimized = optimized
        this.previewVisible = true
      }).catch((error) => {
        const message = error.message || 'AI 优化失败，请稍后重试'
        if (message.includes('请先输入描述内容')) {
          this.$message.warning(message)
        } else if (message.includes('未配置硅基流动 API Key')) {
          this.$message.error(message)
        } else {
          this.$message.error(message)
        }
      }).finally(() => {
        this.aiLoading = false
      })
    },
    applyOptimized () {
      this.currentValue = this.previewOptimized
      this.previewVisible = false
      this.$message.success('已应用 AI 优化内容')
    },
    onPreviewClose () {
      this.previewOriginal = ''
      this.previewOptimized = ''
    },
  },
  filters: {},
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.question-rich-text {
  position: relative;
  line-height: normal;

  .question-rich-text-footer {
    position: absolute;
    bottom: 5px;
    right: 5px;
    z-index: 2;
    pointer-events: auto;
    opacity: 0.8;
    transition: 0.1s opacity ease-in;
  }

  &.has-ai-footer {
    .el-textarea__inner {
      padding-right: 56px;
    }
  }

  &:hover .question-rich-text-footer {
    opacity: 1;
  }

  .el-textarea {
    min-height: 97px;
  }
  .el-textarea__inner {
    min-height: inherit;
    resize: none;

    &:empty:before{
      color: #c7cbd1;
      content: attr(placeholder);
      display: block; /* For Firefox */
    }
  }
}

.ai-preview-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.ai-preview-content {
  min-height: 120px;
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
  line-height: 1.6;
  word-break: break-word;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-rich-text/src/SjQuestionRichText.vue